import { Observable } from "rxjs";
import apiService from "../../ApiService";

type FormData = {
  password: string;
  token: string;
};

export const sendPasswordReset = (data: FormData): Observable<unknown> => {
  return apiService.post({
    path: `public/account/reset_password`,
    body: data,
    crm: true,
  });
};
